if (!customElements.get('fp-process-reveal')) {
 customElements.define('fp-process-reveal', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   const dialog = this.querySelector('dialog');
   const views = [...this.querySelectorAll('[data-full]')];
   const selectors = [...this.querySelectorAll('[data-slide]')];
   let selected = 0;
   let trigger;
   const show = (index) => {
    selected = Number(index);
    views.forEach((view, i) => view.hidden = i !== selected);
    selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
   };
   this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
    trigger = button;
    show(button.dataset.view);
    dialog.showModal();
   }));
   selectors.forEach(button => button.addEventListener('click', () => show(button.dataset.slide)));
   this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
   dialog.addEventListener('close', () => trigger?.focus({ preventScroll: true }));
   dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
   });
   dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(selected === 0 ? 1 : 0); }
   });
   this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
    if (detail.open) this.querySelectorAll('details').forEach(other => { if (other !== detail) other.open = false; });
   }));
  }
 });
}
